export default __webpack_public_path__ + "static/media/48.aceaf26a.jpg";